






































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { MyjbiGroupType } from '@/jbi-shared/types/myjbi-group.types';
import { Group } from '@/store/modules/admin/types/admin.types';
import { get as _get } from 'lodash';
import { PermissionsMatrixActionsEnum } from '../../../store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { EntityTypes } from '../../../store/modules/module-tree/enums/module-tree.enums';
import { isUserAllowed } from '../../../utils/rbac.util';

@Component({
  components: {},
  name: 'GroupRow'
})
export default class GroupRow extends Vue {
  @Prop(Object) public group!: Group;
  @Prop(Function) public getChildren!: (group: Group) => Group[];
  @Prop({ type: Number, default: 1 }) public level!: number;
  @Prop(Boolean) public allGroupsExpanded!: boolean;
  @Prop(Boolean) public expandGroupFilter!: boolean;

  expanded = false;

  get descendants() {
    return this.getChildren(this.group);
  }

  get noSubGroup() {
    return !this.descendants.length;
  }

  get MyjbiGroupType() {
    return MyjbiGroupType;
  }

  get _get() {
    return _get;
  }

  public doesUserHasGroupAccess(): boolean {
    return isUserAllowed(
      PermissionsMatrixActionsEnum.READ,
      'group_administration-groups-read_groups',
      EntityTypes.GROUP,
      this.group.types.name,
      this.group.id,
      undefined,
      true
    );
  }

  @Watch('expandGroupFilter', { immediate: true })
  private onOpenGroupsExpandedChanged() {
    this.expanded = this.expandGroupFilter;
  }
}
